import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { Button } from "src/@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/@/components/ui/dialog";
import { Input } from "src/@/components/ui/input";
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
} from "src/@/components/ui/table";
import MenuDatas2 from "src/components/MenuDatas2";
import { validaLabelMenuDatas } from "src/utils/functions";
import Iconify from "src/components/Iconify";
import { Badge } from "src/@/components/ui/badge";
import Scrollbar from "src/components/Scrollbar";
import { getFriendlyName } from "src/utils/automacoes.utils";
import { fDateTime } from "src/utils/formatTime";
import v2_actionLogsAutomacoes from "src/actions/v2/automacoes/v2_actionLogsAutomacoes";

export function DialogLogsAutomacao({ user }) {
  const { enqueueSnackbar } = useSnackbar();
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenuDatas, setOpenMenuDatas] = useState(false);
  const [inicio, setInicio] = useState(null);
  const [final, setFinal] = useState(null);
  const [periodo, setPeriodo] = useState("mes_atual");

  async function getLogs() {
    try {
      const response = await v2_actionLogsAutomacoes(user.clienteId);
      setLogs(response.data.data);
      setFilteredLogs(response.data.data); // Inicializa a lista filtrada
    } catch (error) {
      console.error(error);
      enqueueSnackbar("Erro ao carregar logs de automação", { variant: "error" });
    }
  }

  useEffect(() => {
    getLogs();
  }, []);

  useEffect(() => {
    const filtered = logs.filter((log) =>
      log.name.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredLogs(filtered);
  }, [searchText, logs]);

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline">Logs de Automação</Button>
      </DialogTrigger>
      <DialogContent className="max-w-7xl min-w-[900px] max-h-[600px]">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between">
            <div>Logs de automação</div>
          </DialogTitle>
        </DialogHeader>

        {/* Filtros */}
        <div className="flex items-center gap-4 my-4 justify-between">
          <div className="w-1/3 flex flex-row items-center gap-2">
            <div className="w-full">
              <Input
                id="search"
                placeholder="Pesquisar"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            <div>
              <MenuDatas2
                anchorEl={anchorEl}
                open={openMenuDatas}
                onClose={() => setAnchorEl(false)}
                inicial={inicio}
                final={final}
                content={validaLabelMenuDatas(periodo, inicio, final)}
                changeInicial={(newValue) => setInicio(newValue)}
                changeFinal={(newValue) => {
                  setFinal(newValue);
                }}
                onSelect={(value) => {
                  setPeriodo(value);
                  setAnchorEl(null);
                  onFiltrar(value, "filtrar");
                }}
                onPesquisar={() => {}}
              />
            </div>
          </div>

          <Button variant="secondary" className="mt-4" onClick={getLogs}>
            <Iconify icon="solar:refresh-bold" className="mr-2" />
            Atualizar logs
          </Button>
        </div>

        <Scrollbar className="h-[600px] min-w-[800px]">
          {/* Tabela de Logs */}
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>ID</TableHead>
                <TableHead>Automação</TableHead>
                <TableHead>Ação</TableHead>
                <TableHead>Data</TableHead>
                <TableHead>Executado</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {filteredLogs.length > 0 ? (
                filteredLogs.map((log) => (
                  <TableRow key={log._id}>
                    <TableCell className="w-[200px]">{log._id}</TableCell>
                    <TableCell>
                      {log.name.substr(0, 30)}
                      {log.name.length > 30 && "..."}
                    </TableCell>
                    <TableCell>{getFriendlyName(log?.scope?.params?.from?.action)}</TableCell>
                    <TableCell className="w-[150px]">{fDateTime(log.date)}</TableCell>
                    <TableCell className="w-[50px]">
                      {log?.scope?.execute ? (
                        <Badge className="bg-green-400">Sim</Badge>
                      ) : (
                        <Badge className="bg-red-400">Não</Badge>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan="5" className="text-center py-4 text-gray-500">
                    Você ainda não executou nenhuma automação. Comece a automatizar e volte aqui
                    para ver o log de atividades de sua automação.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Scrollbar>
      </DialogContent>
    </Dialog>
  );
}
